








































import Component from 'vue-class-component';
import IconButton from '@/components/button/IconButton.vue';
import TextInput from '@/components/input/TextInput.vue';
import CommonButton from '@/components/button/CommonButton.vue';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import CommonPaginatedTable from '@/components/table/CommonPaginatedTable.vue';
import {Mixins} from 'vue-property-decorator';
import {
    CommonModelUtils, DataHistoriesListInfo, DataLibrariesListInfo, DataLibrariesRetrieveResponse, DataSelectLibraryDialogRequest
} from '@/model/CommonModel';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import DefaultPaginateMixin from '@/views/DefaultPaginateMixin';
import '@/plugins/Modal';
import DataApi from '@/api/DataApi';
import DataUtils from '@/utils/DataUtils';
import SelectDialogMixin from '@/components/dialog/SelectDialogMixin';
import MessageUtils from '@/utils/MessageUtils';

@Component({
    components: {
        CommonPromptDialog,
        CommonButton,
        IconButton,
        TextInput,
        CommonPaginatedTable
    },
    mixins: [DialogEventsMixin, DefaultPaginateMixin, SelectDialogMixin],
})
export default class DataSelectLibraryDialog extends Mixins(DialogEventsMixin, DefaultPaginateMixin, SelectDialogMixin) {
    private sponsorKey: number | string;
    private searchWord: string = '';
    
    private onSelect: (context: DataSelectLibraryDialog, row: DataLibrariesListInfo) => void;
    private values: DataHistoriesListInfo[] = [];
    
    get getValues() {
        return this.values;
    }
    
    public mounted() {
        this.sponsorKey = this.$route.params.sponsorKey;
        this.$modal
            .getEventBus()
            .$on('showDataSelectLibraryDialog',
                (request: DataSelectLibraryDialogRequest) => {
                    this.onSelect = request.onSelect;
                    this.retrieve(1, 10);
                    this.show();
                });

        this.$modal.getEventBus().$on('hideDataSelectLibraryDialog', () => this.hide());
    }
    
    public show() {
        if (this.visible) {
            return;
        }
        this.visible = true;
    }
    
    public hide() {
        this.visible = false;
    }
    
    public afterClosed() {
        this.searchWord = '';
        this.columns = [];
        this.values = [];
        this.loading = false;
        this.componentInitialized = false;
    }
    
    private searchLibrary() {
        this.retrieve(1, 10, this.searchWord);
    }
    
    private onLibrariesNavigate(params: any) {
        this.retrieve(params.pageNo, params.rowCount);
    }
    
    protected retrieve(pageNo: string | number, rowCount: string | number, searchWord?: string) {
        this.loading = true;
        return DataApi.retrieveDataLibraries(this.sponsorKey, {exclude: 'Y', pageNo, rowCount, find: searchWord})
                      .then((res: DataLibrariesRetrieveResponse) => {
                          if (!res.success) {
                              return Promise.reject(res.errMsg);
                          }

                          this.columns = DataUtils.getSelectLibrariesColumns(
                              this.$t('message.data.export.selectLibraryDialog.libraryName').toString(),
                              this.$t('message.data.export.selectLibraryDialog.description').toString(),
                          );
                          const paginate = CommonModelUtils.getOrDefaultPaginate(res.data);
                          this.values = paginate.listInfo;
                          this.pageInfo = paginate.pageInfo;
                      })
                      .catch((errMsg) => this.afterRequestFail(errMsg))
                      .finally(() => {
                          this.componentInitialized = true;
                          this.loading = false;
                      });
    }
    
    private onLibraryRowClick(data: any) {
        const {row, $event} = data;
        
        this.onSelect(this, row);
    }
    
    public setLoading(loading: boolean) {
        this.loading = loading;
    }
    
    public destroyed() {
        this.$modal.getEventBus().$off('showDataSelectLibraryDialog');
        this.$modal.getEventBus().$off('hideDataSelectLibraryDialog');
    }
}
